"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationHistoryJson = void 0;
const diff_1 = require("diff");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const DateTime_1 = require("../../DateTime");
require("./index.scss");
const Diff = ({ count, value, added, removed, rowsLimit, isInverted = false, isShowModifiedOnly = true }) => {
    const isModified = !!(added || removed);
    const isCutNeeded = count && rowsLimit && (count - (rowsLimit * 2)) > rowsLimit;
    const modificators = added ? [!isInverted ? 'added' : 'removed'] : removed ? [!isInverted ? 'removed' : 'added'] : [];
    const className = 'json-diff';
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const [hidden, setHidden] = react_1.default.useState(true);
    if (!isModified && isShowModifiedOnly) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classNames },
        !isModified && (react_1.default.createElement(react_1.default.Fragment, null, isCutNeeded && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: `${className}__value` }, value.split('\n').slice(0, rowsLimit).join('\n')),
            react_1.default.createElement("div", { className: `${className}__value ${className}__value--hidden` },
                hidden && (react_1.default.createElement("div", { className: `${className}__switcher`, onClick: () => setHidden(false) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Show', defaultMessage: 'Show hidden lines' }),
                    " (",
                    count - 2 * rowsLimit,
                    ")")),
                !hidden && (react_1.default.createElement("div", { className: `${className}__switcher`, onClick: () => setHidden(true) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Hide', defaultMessage: 'Hide lines' }),
                    " (",
                    count - 2 * rowsLimit,
                    ")")),
                !hidden && (react_1.default.createElement(react_1.default.Fragment, null, value.split('\n').slice(rowsLimit, count - rowsLimit).join('\n'))),
                !hidden && (react_1.default.createElement("div", { className: `${className}__switcher`, onClick: () => setHidden(true) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Hide', defaultMessage: 'Hide lines' }),
                    " (",
                    count - 2 * rowsLimit,
                    ")"))),
            react_1.default.createElement("div", { className: `${className}__value` }, value.split('\n').slice(count - rowsLimit).join('\n')))) || (react_1.default.createElement("div", { className: `${className}__value` }, value)))),
        isModified && (react_1.default.createElement("div", { className: `${className}__value` }, value))));
};
const Summary = ({ snapshot }) => {
    const className = 'snapshot-summary';
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__version` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Version', defaultMessage: 'Version' }),
            " ",
            snapshot.version),
        react_1.default.createElement("div", null,
            react_1.default.createElement("strong", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Responsible', defaultMessage: 'Responsible' })),
            ": ",
            snapshot.user && (snapshot.user.displayName) || (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:System', defaultMessage: 'System' }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("strong", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:CreatedAt', defaultMessage: 'Created at' })),
            ": ",
            react_1.default.createElement(DateTime_1.DateTime, { value: snapshot.createdAt })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("strong", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:Snapshot', defaultMessage: 'Snapshot' })),
            ":")));
};
class ReservationHistoryJson extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.getDiffs = (baseSnapshot, newSnapshot) => {
            return (0, diff_1.diffJson)(baseSnapshot.snapshot, newSnapshot.snapshot);
        };
        this.compareSnapshots = (a, b) => {
            if (a.version === b.version) {
                return 0;
            }
            return a.version > b.version ? -1 : 1;
        };
    }
    render() {
        const { snapshots, modificators } = this.props;
        const className = 'reservation-history-json';
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        const snapshotsCount = snapshots.length;
        return (react_1.default.createElement("div", { className: classNames }, snapshots.sort(this.compareSnapshots).map((snapshot, idx) => {
            var _a;
            const nextSnapshot = (_a = snapshots[idx + 1]) !== null && _a !== void 0 ? _a : snapshot;
            const diffs = this.getDiffs(snapshot, nextSnapshot);
            const hasAnyDifference = diffs.some(item => item.removed || item.added);
            const isFirstSnapshot = idx === (snapshotsCount - 1);
            return (react_1.default.createElement("div", { className: `${className}__item`, key: idx },
                react_1.default.createElement("div", { className: `${className}__summary` },
                    react_1.default.createElement(Summary, { snapshot: snapshot })),
                react_1.default.createElement("div", { className: `${className}__diff` },
                    diffs.map((diff, jdx) => (react_1.default.createElement(Diff, { key: jdx, rowsLimit: this.props.rowsLimit, isInverted: true, isShowModifiedOnly: !isFirstSnapshot, ...diff }))),
                    !hasAnyDifference && !isFirstSnapshot && (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/History:NoChanges', defaultMessage: 'No changes found' })))));
        })));
    }
}
exports.ReservationHistoryJson = ReservationHistoryJson;
ReservationHistoryJson.defaultProps = {
    rowsLimit: 5,
};
//# sourceMappingURL=index.js.map